import { useCallback, useState } from 'react';
import { SaveProgressState } from '../components/save-progress-modal';

export function useSaveProgress() {
  const [saveProgress, setSaveProgress] = useState<SaveProgressState | null>(null);

  const report = useCallback((step: string, percent: number) => {
    setSaveProgress({ step, percent });
  }, []);

  const reset = useCallback(() => setSaveProgress(null), []);

  return { saveProgress, report, reset };
}
